import { render, staticRenderFns } from "./JLottie.vue?vue&type=template&id=f7fdb5ea&scoped=true"
import script from "./JLottie.vue?vue&type=script&lang=js"
export * from "./JLottie.vue?vue&type=script&lang=js"
import style0 from "./JLottie.vue?vue&type=style&index=0&id=f7fdb5ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fdb5ea",
  null
  
)

export default component.exports